import { api } from "./api";

export type FeedbackKind = "bug" | "feature" | "other";
export type FeedbackSeverity = "low" | "medium" | "high" | "blocker";

export interface FeedbackFields {
  kind: FeedbackKind;
  title: string;
  description: string;
  steps?: string;
  expected?: string;
  benefit?: string;
  severity?: FeedbackSeverity;
  pageUrl?: string;
  userAgent?: string;
  appVersion?: string;
}

export interface SubmittedFeedback {
  number: number;
  url: string;
}

export async function submitFeedback(
  fields: FeedbackFields,
  images: File[] = []
): Promise<SubmittedFeedback> {
  const form = new FormData();
  form.append("payload", JSON.stringify(fields));
  for (const image of images) form.append("images", image);

  const { data } = await api.post<{ data: SubmittedFeedback }>(
    "/admin/feedback",
    form
  );
  return data.data;
}
